<template>
	<div>
		<el-card>
			<div slot="header" class="clearfix">
				<i class="el-icon-back backIcon" @click='goBack'></i>
				<span class="topTitle">{{!nextShow?'创建基本信息':'配置指令内容'}}</span>
			</div>
			<el-tabs v-model="activeName" @tab-click="handleClick" v-if="addBody.uuid">
				<el-tab-pane label="中文" name="zh"></el-tab-pane>
				<el-tab-pane label="英文" name="en"></el-tab-pane>
				<el-tab-pane label="日语" name="ja"></el-tab-pane>
			</el-tabs>
			<div style="display: flex;justify-content: space-between;">
				<el-form ref="addBody" :rules="rules" :model="addBody" label-position='top' style="width: 60%;">
					<div v-show="!nextShow">
						<el-form-item label="应用名称"
							:prop="activeName === 'zh' ? 'name' : activeName === 'en' ? 'name_e' : 'name_j'"
							:label-width="formLabelWidth">
							<el-input v-if="activeName=='zh'" v-model="addBody.name" placeholder="请输入应用名称"
								style="width: 766px;"></el-input>
							<el-input v-if="activeName=='en'" v-model="addBody.name_e" placeholder="请输入应用名称"
								style="width: 766px;"></el-input>
							<el-input v-if="activeName=='ja'" v-model="addBody.name_j" placeholder="请输入应用名称"
								style="width: 766px;"></el-input>
						</el-form-item>

						<el-form-item label="应用简介" :label-width="formLabelWidth">
							<el-input v-if="activeName=='zh'" v-model="addBody.content" placeholder="请输入内容" :rows="6"
								type="textarea" style="width: 766px;"></el-input>
							<el-input v-if="activeName=='en'" v-model="addBody.content_e" placeholder="请输入内容" :rows="6"
								type="textarea" style="width: 766px;"></el-input>
							<el-input v-if="activeName=='ja'" v-model="addBody.content_j" placeholder="请输入内容" :rows="6"
								type="textarea" style="width: 766px;"></el-input>
						</el-form-item>

						<el-form-item label="选择分类" prop="class_uuid" :label-width="formLabelWidth">
							<el-select v-model="addBody.class_uuid" style="width: 766px;" placeholder="请选择分类">
								<el-option v-for="item in lmList" :key="item.uuid" :label="item.name"
									:value="item.uuid">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="选择数据集" prop="data_set_uuid" :label-width="formLabelWidth">
							<el-select v-model="addBody.data_set_uuid" style="width: 766px;" placeholder="请选择数据集">
								<el-option v-for="item in shjList" :key="item.uuid" :label="item.name"
									:value="item.uuid">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item v-if="addBody" label="应用头像图片" :label-width="formLabelWidth">
							<ImageUpload v-if="activeName === 'zh'" @input="imageInput" :onloadImageList="imageList"
								:limit="1" type="image"></ImageUpload>
							<ImageUpload v-if="activeName === 'en'" @input="imageInputEn" :onloadImageList="imageListEn"
								:limit="1" type="image"></ImageUpload>
							<ImageUpload v-if="activeName === 'ja'" @input="imageInputJp" :onloadImageList="imageListJp"
								:limit="1" type="image"></ImageUpload>
						</el-form-item>


						<div class="dialog-footer">
							<el-button @click="goBack">取 消</el-button>
							<el-button type="primary" @click="nextShowClick('addBody')">下一步</el-button>
						</div>
					</div>


					<div v-show="nextShow">
						<el-form-item label="插入组件" :label-width="formLabelWidth">
							<!-- <el-radio-group v-model="radio" @change="changeRadio">
								<el-radio :label="1">单行文本</el-radio>
								<el-radio :label="2">多行文本</el-radio>
								<el-radio :label="3">单选框</el-radio>
								<el-radio :label="4">多选框</el-radio>
							</el-radio-group> -->
							<div style="display: flex;align-items: center;">
								<div style="display: flex;align-items: center;margin-right: 20px;cursor: pointer;"
									@click="selectClick(1)">
									<img src="../../assets/dxk.png" style="width: 20px;height: 20px;" />
									<div style="margin-left: 5px;">单行文本</div>
								</div>
								<div style="display: flex;align-items: center;margin-right: 20px;cursor: pointer;"
									@click="selectClick(2)">
									<img src="../../assets/dhwb.png" style="width: 20px;height: 20px;" />
									<div style="margin-left: 5px;">多行文本</div>
								</div>
								<div style="display: flex;align-items: center;margin-right: 20px;cursor: pointer;"
									@click="selectClick(3)">
									<img src="../../assets/dxk.png" style="width: 20px;height: 20px;" />
									<div style="margin-left: 5px;">单选框</div>
								</div>
								<div style="display: flex;align-items: center;margin-right: 20px;cursor: pointer;"
									@click="selectClick(4)">
									<img src="../../assets/duoxk.png" style="width: 20px;height: 20px;" />
									<div style="margin-left: 5px;">多选框</div>
								</div>
							</div>
						</el-form-item>

						<el-form-item label="" prop="desc" :label-width="formLabelWidth">
							<el-input v-if="activeName === 'zh'" id="myInput" @input="inputContent" ref="inputElement"
								@select.native="updateSelection" v-model="moduleContent" placeholder="请输入内容"
								type="textarea" style="width: 766px;" rows='6'></el-input>

							<el-input v-if="activeName === 'en'" id="myInput" @input="inputContent" ref="inputElemente"
								@select.native="updateSelection" v-model="moduleContent_e" placeholder="请输入内容"
								type="textarea" style="width: 766px;" rows='6'></el-input>

							<el-input v-if="activeName === 'ja'" id="myInput" @input="inputContent" ref="inputElementj"
								@select.native="updateSelection" v-model="moduleContent_j" placeholder="请输入内容"
								type="textarea" style="width: 766px;" rows='6'></el-input>

							<div style="color: #6B7280;">请在文本框内编辑指令，选中文本 > 插入组件，让AI应用内容更加丰富</div>
						</el-form-item>



						<div class="dialog-footer">
							<el-button @click="nextShow=false">上一步</el-button>
							<el-button type="primary" @click="editUser('addBody')">创建</el-button>
						</div>
					</div>

				</el-form>


				<el-form label-width="120px" ref="form" v-if="nextShow" label-position='top' style="width: 40%;">
					<template v-for="(item, index) in showItems">
						<!-- 单行文本 -->
						<el-form-item v-if="item.type === 1" :key="item.module_id" label="" :prop="item.module_id">
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<div>{{item.name}}</div>
								<div style="display: flex;align-items: center;">
									<i class="el-icon-edit" @click="inputEditValue(item,index)"></i>
									<i class="el-icon-delete" @click="deleteInputValue(item,index)"
										style="margin-left: 20px;"></i>
								</div>
							</div>
							<el-input v-model="item.value" :placeholder="item.remake" clearable>
							</el-input>
						</el-form-item>

						<!-- 多行文本 -->
						<el-form-item v-if="item.type === 2" :key="item.module_id" label="" :prop="item.module_id">
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<div>{{item.name}}</div>
								<div style="display: flex;align-items: center;">
									<i class="el-icocn-edit" @click="inputEditValue(item,index)"></i>
									<i class="el-icon-delete" @click="deleteInputValue(item,index)"
										style="margin-left: 20px;"></i>
								</div>
							</div>
							<el-input v-model="item.value" type="textarea" :rows="4" :placeholder="item.remake">
							</el-input>
						</el-form-item>

						<!-- 单选框 -->
						<el-form-item v-if="item.type === 3 && item.tag==1" :key="item.module_id" label=""
							:prop="item.module_id">
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<div>{{item.name}}</div>
								<div style="display: flex;align-items: center;">
									<i class="el-icon-edit" @click="inputEditValue(item,index)"></i>
									<i class="el-icon-delete" @click="deleteInputValue(item,index)"
										style="margin-left: 20px;"></i>
								</div>
							</div>
							<div><span style="color: #ff0000;">*</span>{{item.remake}}</div>
							<!-- <el-radio-group v-model="item.value">
								<el-radio :label="_item"
									v-for="(_item,_index) in getOptions(item.content)">{{_item}}</el-radio>
							</el-radio-group> -->
							<div style="display: flex;align-items: center;flex-wrap: wrap">
								<el-button type="info" style="margin-bottom: 10px;" plain
									v-for="(_item,_index) in getOptions(item.content)">{{_item}}</el-button>
							</div>
						</el-form-item>
						<el-form-item v-if="item.type === 3 && item.tag==2" :key="item.module_id" label=""
							:prop="item.module_id">
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<div>{{item.name}}</div>
								<div style="display: flex;align-items: center;">
									<i class="el-icon-edit" @click="inputEditValue(item,index)"></i>
									<i class="el-icon-delete" @click="deleteInputValue(item,index)"
										style="margin-left: 20px;"></i>
								</div>
							</div>
							<el-select v-model="item.value" :placeholder="item.remake">
								<el-option v-for="(_item,_index) in getOptions(item.content)" :key="_index"
									:label="_item" :value="_index">
								</el-option>
							</el-select>
						</el-form-item>

						<!-- 多选框 -->
						<el-form-item v-if="item.type === 4 && item.tag==1" :key="item.module_id" label=""
							:prop="item.module_id">
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<div>{{item.name}}</div>
								<div style="display: flex;align-items: center;">
									<i class="el-icon-edit" @click="inputEditValue(item,index)"></i>
									<i class="el-icon-delete" @click="deleteInputValue(item,index)"
										style="margin-left: 20px;"></i>
								</div>
							</div>
							<el-checkbox-group v-model="item.value">
								<el-checkbox :label="_item"
									v-for="(_item,_index) in getOptions(item.content)"></el-checkbox>
							</el-checkbox-group>
						</el-form-item>
						<el-form-item v-if="item.type === 4 && item.tag==2" :key="item.module_id" label=""
							:prop="item.module_id">
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<div>{{item.name}}</div>
								<div style="display: flex;align-items: center;">
									<i class="el-icon-edit" @click="inputEditValue(item,index)"></i>
									<i class="el-icon-delete" @click="deleteInputValue(item,index)"
										style="margin-left: 20px;"></i>
								</div>
							</div>
							<el-select v-model="item.value" multiple :placeholder="item.remake">
								<el-option v-for="(_item,_index) in getOptions(item.content)" :key="_index"
									:label="_item" :value="_index">
								</el-option>
							</el-select>
						</el-form-item>


					</template>
				</el-form>
			</div>
		</el-card>


		<el-dialog :close-on-click-modal='false' :title="radio==1?'添加单行文本框':radio==2?'添加多行文本框':radio==3?'添加单选框':'添加多选框'"
			:visible.sync="dialogShow" width="30%" :before-close="handleClose">
			<div class="sbtitle" style="margin-bottom: 10px;">
				{{radio==1?'文本框标题':radio==2?'文本框标题':radio==3?'单选框标题':'多选框标题'}}
			</div>
			<el-input v-model="selectedText" @input="inputValAdd"></el-input>
			<!-- <el-input v-model="selectedText" :disabled='true'></el-input> -->

			<div class="sbtitle" style="margin-bottom: 10px;margin-top: 20px;">组件说明</div>
			<el-input v-model="moduleItem.remake" placeholder="请输入组件说明"></el-input>

			<div v-if="radio == 3||radio==4">
				<div class="sbtitle" style="margin-bottom: 10px;margin-top: 20px;">{{radio==3?'单选框样式':'多选框样式'}}</div>
				<el-radio-group v-model="moduleItem.tag" @change="changeRadio">
					<el-radio :label="1">标签按钮样式</el-radio>
					<el-radio :label="2">下拉选框样式</el-radio>
				</el-radio-group>

				<div class="sbtitle" style="margin-bottom: 10px;margin-top: 20px;">选项内容</div>
				<el-input v-model="moduleItem.content" placeholder="每行一个选项" type="textarea" rows='6'></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirmModuleItem">确 定</el-button>
			</span>
		</el-dialog>


		<el-dialog :close-on-click-modal='false'
			:title="editModuleItem.type==1?'编辑单行文本框':editModuleItem.type==2?'编辑多行文本框':editModuleItem.type==3?'编辑单选框':'编辑多选框'"
			:visible.sync="editDialogShow" width="30%" :before-close="handleClose">
			<div class="sbtitle" style="margin-bottom: 10px;">
				{{editModuleItem.type==1?'文本框标题':editModuleItem.type==2?'文本框标题':editModuleItem.type==3?'单选框标题':'多选框标题'}}
			</div>
			<el-input v-model="editModuleItem.name" @input="inputVal"></el-input>

			<div class="sbtitle" style="margin-bottom: 10px;margin-top: 20px;">组件说明</div>
			<el-input v-model="editModuleItem.remake" placeholder="请输入组件说明"></el-input>

			<div v-if="editModuleItem.type == 3||editModuleItem.type==4">
				<div class="sbtitle" style="margin-bottom: 10px;margin-top: 20px;">
					{{editModuleItem.type==3?'单选框样式':'多选框样式'}}
				</div>
				<el-radio-group v-model="editModuleItem.tag" @change="changeRadio">
					<el-radio :label="1">标签按钮样式</el-radio>
					<el-radio :label="2">下拉选框样式</el-radio>
				</el-radio-group>

				<div class="sbtitle" style="margin-bottom: 10px;margin-top: 20px;">选项内容</div>
				<el-input v-model="editModuleItem.content" placeholder="每行一个选项" type="textarea" rows='6'></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirmModuleItemEdit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getDataSets,
		addAiapplication,
		editAiapplication,
		getAiapplication,
		getAiApplicationClass
	} from "@/api/area-manage"
	import ImageUpload from "@/components/ImageUpload"
	export default {
		components: {
			ImageUpload
		},
		data() {
			return {
				editDialogShow: false,
				dialogShow: false,
				nextShow: false,
				activeName: 'zh',
				formLabelWidth: '120px',
				addBody: {
					uuid: '',
					name: '',
					name_e: '',
					name_j: '',
					content: '',
					content_e: '',
					content_j: '',
					image: '',
					image_e: '',
					image_j: '',
					class_uuid: '',
					data_set_uuid: '',
					module_item: [],
				},
				moduleItem: {
					type: '',
					name: '',
					remake: '',
					tag: 1,
					content: '',
					module_id: '',
					application_uuid: '',
					value: ''
				},
				editModuleItem: {
					type: '',
					name: '',
					remake: '',
					tag: 1,
					content: '',
					module_id: '',
					application_uuid: '',
					value: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					data_set_uuid: [{
						required: true,
						message: '请选择数据集',
						trigger: 'blur'
					}, ],
					class_uuid: [{
						required: true,
						message: '请选择分类',
						trigger: 'blur'
					}, ],
					name: [{
						required: true,
						message: '请输入应用名称',
						trigger: 'blur'
					}, ],
					name_e: [{
						required: true,
						message: '请输入应用名称',
						trigger: 'blur'
					}, ],
					name_j: [{
						required: true,
						message: '请输入应用名称',
						trigger: 'blur'
					}, ],
					content: [{
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					}, ],
					content_e: [{
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					}, ],
					content_j: [{
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					}, ],
					image: [{
						required: true,
						message: '请上传头像',
						trigger: 'blur'
					}, ],
					image_e: [{
						required: true,
						message: '请上传头像',
						trigger: 'blur'
					}, ],
					image_j: [{
						required: true,
						message: '请上传头像',
						trigger: 'blur'
					}, ],
				},
				lmList: [],
				shjList: [],
				imageList: [],
				imageListEn: [],
				imageListJp: [],
				radio: 0,
				selectedText: '',
				moduleContent: '',
				moduleContent_e: '',
				moduleContent_j: '',
				newStr: '',
				oldText: '',
				selectInputDatas: [],
				valueName: '',
				editCurrentIndex: -1,
				newModuleItems:[],
				showItems:[]
			}
		},
		mounted() {
			this.getDataSets()
			this.addBody.uuid = this.$route.query.uuid
			if (this.addBody.uuid) {
				this.network().getAiapplication(this.addBody.uuid)
			}
			this.network().getAiApplicationClass()
		},
		methods: {
			inputEditValue(item, index) {
				this.editCurrentIndex = index
				this.editModuleItem = item
				this.editDialogShow = true
			},
			deleteInputValue(item, index) {
				this.editModuleItem = item
				const result = this.activeName == 'zh' ? this.moduleContent.match(/{[^}]+}/g) : this.activeName == 'en' ?
					this.moduleContent_e.match(/{[^}]+}/g) : this.moduleContent_j.match(/{[^}]+}/g);

				let text = this.editModuleItem.type == 1 ? '单行' : this.editModuleItem.type == 2 ? '多行' : this
					.editModuleItem.type == 3 ? '单选框' : '多选框'
				let inputText = '{' + this.editModuleItem.name + ' ' + '|' + ' ' + text + '}'

				this.addBody.module_item.splice(index, 1)
				let arrs = this.addBody.module_item
				if(this.activeName == 'zh'){
					this.showItems = arrs.filter(item=>{
						return item.language == 'cn'
					})
				}
				if(this.activeName == 'en'){
					this.showItems = arrs.filter(item=>{
						return item.language == 'en'
					})
				}
				if(this.activeName == 'ja'){
					this.showItems = arrs.filter(item=>{
						return item.language == 'ja'
					})
				}
				this.moduleContent = this.activeName == 'zh' ? this.moduleContent.replace(inputText, '') : this
					.activeName == 'zh' ? this.moduleContent_e.replace(inputText, '') : this.moduleContent_j.replace(
						inputText,
						'')
			},
			inputContent() {
				// if (this.activeName == 'zh') {
				// 	this.addBody.module_item = this.getAddBody(this.moduleContent, this.addBody.module_item)
				// }
				// if (this.activeName == 'en') {
				// 	this.addBody.module_item = this.getAddBody(this.moduleContent_e, this.addBody.module_item)
				// }
				// if (this.activeName == 'ja') {
				// 	this.addBody.module_item = this.getAddBody(this.moduleContent_j, this.addBody.module_item)
				// }
			},
			getOptions(content) {
				return content.split('\n').filter(t => t.trim());
			},
			inputValAdd(e) {
				this.selectedText = e
			},
			inputVal(e) {},
			confirmModuleItemEdit() {
				const result = this.activeName == 'zh' ? this.moduleContent.match(/{[^}]+}/g) : this.activeName == 'en' ?
					this.moduleContent_e.match(/{[^}]+}/g) : this.moduleContent_j.match(/{[^}]+}/g);
				let text = this.editModuleItem.type == 1 ? '单行' : this.editModuleItem.type == 2 ? '多行' : this
					.editModuleItem.type == 3 ? '单选框' : '多选框'
				if (this.activeName == 'zh') {
					this.moduleContent = this.moduleContent.replace(result[this.editCurrentIndex], '{' + this
						.editModuleItem
						.name + ' ' + '|' + ' ' + text + '}')
				}
				if (this.activeName == 'en') {
					this.moduleContent_e = this.moduleContent_e.replace(result[this.editCurrentIndex], '{' + this
						.editModuleItem
						.name + ' ' + '|' + ' ' + text + '}')
				}
				if (this.activeName == 'ja') {
					this.moduleContent_j = this.moduleContent_j.replace(result[this.editCurrentIndex], '{' + this
						.editModuleItem
						.name + ' ' + '|' + ' ' + text + '}')
				}
				this.handleClose()
			},
			confirmModuleItem() {
				// this.moduleContent = ''
				if (this.activeName == 'zh') {
					if (!this.selectedText) return this.$message.error('请输入内容')
					if (!this.moduleItem.remake) return this.$message.error('请输入内容')
					let stextArr = this.moduleContent.toString().split(this.valueName)
					if (stextArr.length == 1) {
						this.moduleContent = stextArr[0] + this.selectedText
					} else {
						this.moduleContent = stextArr[0] + this.selectedText
						for (let i = 1; i < stextArr.length; i++) {
							this.moduleContent += stextArr[i]
						}
					}

					// this.moduleContent = this.moduleContent.replaceAll(this.valueName, this.selectedText)
					this.valueName = this.selectedText
					let startText = ''
					let endText = ''
					let selArr = this.moduleContent.split(this.selectedText)
					if (selArr.length == 1) {
						startText = this.moduleContent.split(this.selectedText)[0]
					} else {
						startText = this.moduleContent.split(this.selectedText)[0]
						endText = this.moduleContent.split(this.selectedText)[1]
					}

					this.newStr = ''
					let newStr = this.moduleContent.replace(this.selectedText, '')
					this.moduleContent = newStr
					let text = this.radio == 1 ? '单行' : this.radio == 2 ? '多行' : this
						.radio == 3 ? '单选框' : '多选框'
					// let modeData = this.moduleContent + '{' + this.selectedText + ' | ' + text + '} '
					let modeData = startText + '{' + this.selectedText + ' | ' + text + '} ' + endText
					this.newStr = this.newStr + modeData
					this.moduleContent = this.newStr
					this.moduleItem.type = this.radio
					this.moduleItem.name = this.selectedText
					this.moduleItem.module_id = this.generateUUID()
					this.moduleItem.language = 'cn'
					this.addBody.module_item.push({
						...this.moduleItem
					})
					this.handleClose()
					this.dialogShow = false
				}
				if (this.activeName == 'en') {
					if (!this.selectedText) return this.$message.error('请输入内容')
					if (!this.moduleItem.remake) return this.$message.error('请输入内容')
					let stextArr = this.moduleContent_e.toString().split(this.valueName)
					if (stextArr.length == 1) {
						this.moduleContent_e = stextArr[0] + this.selectedText
					} else {
						this.moduleContent_e = stextArr[0] + this.selectedText
						for (let i = 1; i < stextArr.length; i++) {
							this.moduleContent_e += stextArr[i]
						}
					}

					// this.moduleContent_e = this.moduleContent_e.replaceAll(this.valueName, this.selectedText)
					this.valueName = this.selectedText
					let startText = ''
					let endText = ''
					let selArr = this.moduleContent_e.split(this.selectedText)
					if (selArr.length == 1) {
						startText = this.moduleContent_e.split(this.selectedText)[0]
					} else {
						startText = this.moduleContent_e.split(this.selectedText)[0]
						endText = this.moduleContent_e.split(this.selectedText)[1]
					}

					this.newStr = ''
					let newStr = this.moduleContent_e.replace(this.selectedText, '')
					this.moduleContent_e = newStr
					let text = this.radio == 1 ? '单行' : this.radio == 2 ? '多行' : this
						.radio == 3 ? '单选框' : '多选框'
					// let modeData = this.moduleContent_e + '{' + this.selectedText + ' | ' + text + '} '
					let modeData = startText + '{' + this.selectedText + ' | ' + text + '} ' + endText
					this.newStr = this.newStr + modeData
					this.moduleContent_e = this.newStr
					this.moduleItem.type = this.radio
					this.moduleItem.name = this.selectedText
					this.moduleItem.module_id = this.generateUUID()
					this.moduleItem.language = 'en'
					this.addBody.module_item.push({
						...this.moduleItem
					})
					this.handleClose()
					this.dialogShow = false
				}
				if (this.activeName == 'ja') {
					if (!this.selectedText) return this.$message.error('请输入内容')
					if (!this.moduleItem.remake) return this.$message.error('请输入内容')
					let stextArr = this.moduleContent_j.toString().split(this.valueName)
					if (stextArr.length == 1) {
						this.moduleContent_j = stextArr[0] + this.selectedText
					} else {
						this.moduleContent_j = stextArr[0] + this.selectedText
						for (let i = 1; i < stextArr.length; i++) {
							this.moduleContent_j += stextArr[i]
						}
					}

					// this.moduleContent_j = this.moduleContent_j.replaceAll(this.valueName, this.selectedText)
					this.valueName = this.selectedText
					let startText = ''
					let endText = ''
					let selArr = this.moduleContent_j.split(this.selectedText)
					if (selArr.length == 1) {
						startText = this.moduleContent_j.split(this.selectedText)[0]
					} else {
						startText = this.moduleContent_j.split(this.selectedText)[0]
						endText = this.moduleContent_j.split(this.selectedText)[1]
					}

					this.newStr = ''
					let newStr = this.moduleContent_j.replace(this.selectedText, '')
					this.moduleContent_j = newStr
					let text = this.radio == 1 ? '单行' : this.radio == 2 ? '多行' : this
						.radio == 3 ? '单选框' : '多选框'
					// let modeData = this.moduleContent_j + '{' + this.selectedText + ' | ' + text + '} '
					let modeData = startText + '{' + this.selectedText + ' | ' + text + '} ' + endText
					this.newStr = this.newStr + modeData
					this.moduleContent_j = this.newStr
					this.moduleItem.type = this.radio
					this.moduleItem.name = this.selectedText
					this.moduleItem.module_id = this.generateUUID()
					this.moduleItem.language = 'ja'
					this.addBody.module_item.push({
						...this.moduleItem
					})
					this.handleClose()
					this.dialogShow = false
				}
				this.newModuleItems = this.addBody.module_item
				let arrs = this.newModuleItems
				if(this.activeName == 'zh'){
					this.showItems = arrs.filter(item=>{
						return item.language == 'cn'
					})
				}
				if(this.activeName == 'en'){
					this.showItems = arrs.filter(item=>{
						return item.language == 'en'
					})
				}
				if(this.activeName == 'ja'){
					this.showItems = arrs.filter(item=>{
						return item.language == 'ja'
					})
				}
			},
			generateUUID() {
				let d = new Date().getTime();
				const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
					const r = (d + Math.random() * 16) % 16 | 0;
					d = Math.floor(d / 16);
					return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
				});
				return uuid;
			},
			handleClose() {
				this.selectedText = ''
				this.radio = 0
				this.moduleItem.type = ''
				this.moduleItem.name = ''
				this.moduleItem.remake = ''
				this.moduleItem.content = ''
				this.moduleItem.tag = 1
				this.moduleItem.content = ''
				this.moduleItem.module_id = ''
				this.moduleItem.application_uuid = ''
				this.selectedText = ''
				this.dialogShow = false
				this.editDialogShow = false
			},
			// 处理文本选择事件
			updateSelection() {
				// 关键点2: 获取原生textarea元素
				const textarea = this.activeName == 'zh' ? this.$refs.inputElement.$el.querySelector('textarea') : this
					.activeName == 'en' ? this.$refs.inputElemente.$el.querySelector('textarea') : this.$refs.inputElementj
					.$el.querySelector('textarea')

				// 关键点3: 正确获取选择范围
				const start = textarea.selectionStart
				const end = textarea.selectionEnd
				if (start !== end) {
					this.selectedText = this.activeName == 'zh' ? this.moduleContent.substring(start, end) : this
						.activeName == 'en' ? this.moduleContent_e.substring(start, end) : this.moduleContent_j.substring(
							start, end)
					this.valueName = this.selectedText
				} else {
					this.selectedText = ''
				}
			},
			changeRadio(e) {
				if (!this.selectedText) {
					this.radio = 0
					this.$message.error('请选择文本')
				} else {
					this.dialogShow = true
				}
			},
			selectClick(e) {
				this.radio = e
				if (!this.selectedText) {
					this.radio = 0
					this.$message.error('请选择文本')
				} else {
					this.dialogShow = true
				}
			},
			imageInput(e) {
				this.addBody.image = e[0]
				this.addBody.image_e = e[0]
				this.addBody.image_j = e[0]
			},
			imageInputEn(e) {
				this.addBody.image_e = e[0]
			},
			imageInputJp(e) {
				this.addBody.image_j = e[0]
			},
			handleClick(e, a) {
				this.activeName = e.name
				let arrs = this.newModuleItems
				if(this.activeName == 'zh'){
					this.showItems = arrs.filter(item=>{
						return item.language == 'cn'
					})
				}
				if(this.activeName == 'en'){
					this.showItems = arrs.filter(item=>{
						return item.language == 'en'
					})
				}
				if(this.activeName == 'ja'){
					this.showItems = arrs.filter(item=>{
						return item.language == 'ja'
					})
				}
				// this.network().getAiapplication(this.addBody.uuid)
			},
			async getDataSets() {
				const {
					status,
					data
				} = await getDataSets({})
				this.shjList = data.result.my_item
			},
			goBack() {
				this.$router.go(-1)
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			nextShowClick(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.nextShow = true
					} else {
						return false;
					}
					return false
				});
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (!(this.activeName == 'zh' ? this.moduleContent : this.activeName == 'en' ? this
								.moduleContent_e : this.moduleContent_j)) {
							return this.$message.error('请输入指令')
						}
						if (this.addBody.uuid) {
							this.network().editAiapplication()
						} else {
							this.network().addAiapplication()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			getAddBody(txt, module_item) {
				// 解析 txt 字符串
				const regex = /\{([^|]+) \| [^\}]+\}/g;
				let matches;
				const namesToShow = new Set();

				while ((matches = regex.exec(txt)) !== null) {
					const name = matches[1].trim(); // 提取 name
					namesToShow.add(name); // 将提取的 name 添加到集合中
				}

				// 筛选 module_item
				const filteredModuleItems = module_item.filter(item =>
					namesToShow.has(item.name) // 使用 name 进行匹配
				);
				return filteredModuleItems
			},
			network() {
				return {
					getAiApplicationClass: async () => {
						const {
							status,
							data
						} = await getAiApplicationClass()
						this.lmList = data.result.data
					},
					addAiapplication: async () => {
						const {
							status,
							data
						} = await addAiapplication({
							...this.addBody,
							module_item: this.addBody.module_item,
							txt: this.moduleContent,
							txt_e: this.moduleContent_e,
							txt_j: this.moduleContent_j,
							language: this.activeName == 'zh' ? 'cn' : this.activeName == 'en' ? 'en' : 'ja'
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
						this.$router.go(-1)
					},
					editAiapplication: async () => {
						const {
							status
						} = await editAiapplication({
							...this.addBody,
							module_item: this.addBody.module_item,
							txt: this.moduleContent,
							txt_e: this.moduleContent_e,
							txt_j: this.moduleContent_j,
							language: this.activeName == 'zh' ? 'cn' : this.activeName == 'en' ? 'en' : 'ja'
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
						this.$router.go(-1)
					},
					getAiapplication: async (uuid) => {
						const {
							data,
							status
						} = await getAiapplication({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
						if (data.result.image != null && data.result.image) {
							this.imageList.push(data.result.image)
						}
						if (data.result.image_e != null && data.result.image_e) {
							this.imageListEn = data.result.image_e.split(',')
						}
						if (data.result.image_j != null && data.result.image_j) {
							this.imageListJp = data.result.image_j.split(',')
						}

						// this.addBody.module_item.forEach(item => {
						// 	let text = item.type == 1 ? '单行' : item.type == 2 ? '多行' : item.type == 3 ? '单选框' :
						// 		'多选框'
						// 	this.moduleContent += '{' + item.name + ' | ' + text + '} '
						// })
						// this.newStr += this.moduleContent
						this.moduleContent = this.addBody.txt + ' '
						this.moduleContent_e = this.addBody.txt_e + ' '
						this.moduleContent_j = this.addBody.txt_j + ' '
						this.newModuleItems = this.addBody.module_item
						let arrs = this.newModuleItems
						if(this.activeName == 'zh'){
							this.showItems = arrs.filter(item=>{
								return item.language == 'cn'
							})
						}
						if(this.activeName == 'en'){
							this.showItems = arrs.filter(item=>{
								return item.language == 'en'
							})
						}
						if(this.activeName == 'ja'){
							this.showItems = arrs.filter(item=>{
								return item.language == 'ja'
							})
						}
					},
				}
			},
		},
	}
</script>

<style>
	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.el-radio__original {

		display: none !important;
		/* 隐藏原生 radio 输入，但仍然允许交互 */

	}

	.el-icon-edit {
		cursor: pointer;
	}

	.el-icon-delete {
		cursor: pointer;
	}
</style>